(function ($) {



    $(document).on('ready', function () {


        $(document).on('click', '[data-share-link]', function (e) {
            e.preventDefault();

            var url = $(this).attr('data-share-link');

            if (!url) {
                return false;
            }

            var popupWidth = 600;
            var popupHeight = 600;

            var dualScreenLeft = window.screenX !== undefined ? window.screenX : window.screenLeft;
            var dualScreenTop = window.screenY !== undefined ? window.screenY : window.screenTop;

            var windowWidth = window.outerWidth || document.documentElement.clientWidth;
            var windowHeight = window.outerHeight || document.documentElement.clientHeight;

            var left = Math.round(dualScreenLeft + (windowWidth - popupWidth) / 2);
            var top = Math.round(dualScreenTop + (windowHeight - popupHeight) / 2);

            var popup = window.open(
                url,
                'shareWindow',
                'scrollbars=yes,resizable=yes,width=' + popupWidth + ',height=' + popupHeight + ',top=' + top + ',left=' + left
            );

            if (popup) {
                popup.focus();
            }

            return false;
        });

    });


})(jQuery);